// extracted by mini-css-extract-plugin
export default {"wrapper":"CollectionYardsSettingsPage_wrapper__CNJFK","wrapperItems":"CollectionYardsSettingsPage_wrapperItems__SlhE2","item":"CollectionYardsSettingsPage_item__3YPZw"};